import { Pipe, PipeTransform } from '@angular/core';
import { Order, OrderItem } from '../api/contracts/order';
import { OrderItemStatus } from '../types/order';
import { OrderService } from '../services/order.service';

@Pipe({
  name: 'getOrderItemStatus',
})
export class GetOrderItemStatusPipe implements PipeTransform {
  constructor(private readonly orderService: OrderService) {}

  transform(order: Order, orderItem: OrderItem): OrderItemStatus {
    return this.orderService.getOrderItemStatus(order, orderItem);
  }
}
